import { useEffect, useRef, useState } from "react";
import "./index.css";

interface Partner {
  url: string;
  website: string;
}

interface InfinitePartnerScrollProps {
  partners: Partner[];
  speed?: number;
}

const InfinitePartnerScroll = ({
  partners,
  speed = 0.5,
}: InfinitePartnerScrollProps) => {
  const [isPaused, setIsPaused] = useState(false);
  const scrollerRef = useRef<HTMLDivElement>(null);
  const translateRef = useRef(0);
  const [duplicatedPartners, setDuplicatedPartners] = useState<Partner[]>([]);
  const animationRef = useRef<number>();

  useEffect(() => {
    // 复制足够多的内容以确保流畅滚动
    setDuplicatedPartners([...partners, ...partners, ...partners, ...partners]);
  }, [partners]);

  useEffect(() => {
    if (!scrollerRef.current) return;

    const animate = () => {
      if (!isPaused && scrollerRef.current) {
        // 增量移动，使动画更平滑
        translateRef.current += speed;

        const singleWidth = scrollerRef.current.scrollWidth / 4;

        // 当超过一组宽度时重置位置
        if (translateRef.current >= singleWidth) {
          translateRef.current = 0;
        }

        // 使用 transform3d 触发 GPU 加速
        scrollerRef.current.style.transform = `translate3d(${-translateRef.current}px, 0, 0)`;
      }

      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [isPaused, speed]);

  return (
    <div
      className="partner-scroll-container"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
      onTouchStart={() => setIsPaused(true)}
      onTouchEnd={() => setIsPaused(false)}
    >
      <div ref={scrollerRef} className="partner-scroll-content">
        {duplicatedPartners.map((partner, index) => (
          <div
            key={`${index}`}
            className="partner-item"
            onClick={() => {
              if (partner.website) {
                window.open(partner.website, "_blank");
              }
            }}
          >
            <img src={partner.url} className="partner-image" loading="lazy" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default InfinitePartnerScroll;
